const API_URL = 'https://gorest.co.in/public-api/';

export const USERS_URL = `${API_URL}users`;
export const POSTS_URL = `${API_URL}posts`;
